/**
 * Created by stonewang on 2017/9/10.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Tree, Icon, Radio } from 'antd';//Input
import './style.css';
// import { getOrgTree } from '../service/product';
const TreeNode = Tree.TreeNode;
//const Search = Input.Search;

class SelectRange extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      // options: [],
      selectedKeys: [],
      selectedNodes: [],
      choseType:'area',
      checked: false
    }
    this.handleSave = this.handleSave.bind(this);
    this.onChange = this.onChange.bind(this);
    this.deleteMsg = this.deleteMsg.bind(this);
    this.treeSelect = this.treeSelect.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.searchRange = this.searchRange.bind(this);
    this.getselectedKeys = this.getselectedKeys.bind(this);
  }

  componentDidMount() {
    // const self =this;
    // getOrgTree().then(res => { //资讯发布的范围
    //   if(res.data && res.data.length>0){
    //     self.setState({options: res.data});
    //   }
    // });
  }

  showModal = () => {
    const { keys, nodes } = this.props;
    this.setState({
      visible: true,
      selectedKeys: keys || [],
      selectedNodes: nodes || [],
    });
  };
  handleCancel = (e) => {
    this.setState({
      visible: false,
      selectedKeys: [],
      selectedNodes: [],
    });
  };
  onChange = (e)=> {
    this.setState({
      choseType: e.target.value
    });
    if(this.props.chose){
      this.props.chose(e.target.value);
    }
  };

  handleSave() {
    this.setState({ visible: false })
    if (this.props.onOk) {
      const { selectedNodes, selectedKeys } = this.state;
      this.props.onOk(selectedKeys, selectedNodes);
    }
  }

  treeSelect(selectedKeys, info) {
    const selectedNodes = info.checkedNodes.map(item => {
      return {
        name: item.props.title,
        key: item.key,
        checked: false,
      }
    })
    this.setState({
      selectedKeys,
      selectedNodes
    })
    return info;
  }

  deleteMsg(index) {
    let { selectedNodes, selectedKeys } = this.state;
    selectedKeys.splice(index, 1);
    selectedNodes.splice(index, 1);
    this.setState({
      selectedKeys,
      selectedNodes,
      checked: false,
    })
  }

  //搜索框搜索
  getselectedKeys(value, arr) {
    let selectedKeys;
    let selectedvalue;
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].parent == value) {
        selectedKeys = `${arr[i].key}_${i}`;
        selectedvalue = arr[i].parent;
        break;
      } else {
        const node = arr[i];
        if (node.leaf) {
          for (var j = 0; j < node.leaf.length; j++) {
            if (node.leaf[j].parent == value) {
              selectedKeys = `${node.leaf[j].key}_${j}`;
              selectedvalue = node.leaf[j].parent;
              break;
            } else {
              selectedKeys = this.getselectedKeys(value, node.leaf).selectedKeys;
              selectedvalue = this.getselectedKeys(value, node.leaf).selectedvalue;
            }
          }
        }
      }
    }
    return { selectedKeys, selectedvalue };
  }

  searchRange(value) {
    var selectedKeys = this.getselectedKeys(value, this.state.tree).selectedKeys;
    var selectedvalue = this.getselectedKeys(value, this.state.tree).selectedvalue;
    if (selectedKeys && selectedvalue) {
      var arrmsg = this.state.selected;
      arrmsg.push(selectedvalue);
      this.setState({
        selected: arrmsg,
        selectkey: selectedKeys
      })
    } else {
      alert('未搜索到相关范围');
    }
  }

  render() {
    const self = this;
    const { selectedKeys, selectedNodes, visible, checked } = this.state;
    const modalOpts = {
      title: '选择发布范围',
      visible: visible,
      onCancel: self.handleCancel,
      footer: [
        <Button key="0" size="large" onClick={self.handleCancel}>取消</Button>,
        <Button key="1" type="primary" size="large" onClick={self.handleSave}>
          确定
        </Button>,
      ]
    };

    const loop = data => data.map((item, key) => {
      if (item.children && item.children.length) {
        return <TreeNode key={`${item.key}`} title={item.label}>{loop(item.children)}</TreeNode>;
      }
      return <TreeNode key={`${item.key}`} title={item.label} />;
    });
    return (
      visible ? <Modal {...modalOpts} width={800}>
        <div className="modalMain">
          <Radio.Group defaultValue="area" size="large" style={{ display: 'block' }} onChange={this.onChange}>
            <Radio.Button value="area">区域</Radio.Button>
            <Radio.Button value="organization">组织</Radio.Button>
          </Radio.Group>
          <div className="modalLeft">
            <Tree autoExpandParent={false}
                  multiple={true}
                  checkable={true}
                  checked={checked}
                  onCheck={this.treeSelect}
                  checkedKeys={selectedKeys}
            >
              {loop(this.props.options)}
            </Tree>
          </div>
          <Icon type="right" className='modalIcon' />
          <div className="modalRight">
            {
              selectedNodes.map((item, key) => {
                return (
                  <p key={key} className='modalP'>
                    <span className='modalPs'>{item.name}</span>
                    <Icon className='closeIcon' type="close"
                          onClick={this.deleteMsg.bind(this, key)} />
                  </p>
                )
              })
            }
          </div>
        </div>
      </Modal> : null
    )
  }
}
SelectRange.propTypes = {
  onOk: PropTypes.func,
  keys: PropTypes.array,
  nodes: PropTypes.array,
  options: PropTypes.array,
  chose: PropTypes.func,
};
export default SelectRange;


// WEBPACK FOOTER //
// ./src/components/selectRange.js